/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboGroupModifierRequestSchema } from "./calculateDiscountComboGroupModifierRequestSchema.ts";
import { calculateDiscountComboModifierRequestSchema } from "./calculateDiscountComboModifierRequestSchema.ts";

export const calculateDiscountComboItemRequestSchema = z
	.object({
		id: z.uuid(),
		amount: z.int().min(1),
		size: z.uuid().nullish(),
		modifiers: z.array(calculateDiscountComboModifierRequestSchema).nullish(),
		group_modifiers: z.array(calculateDiscountComboGroupModifierRequestSchema).nullish(),
	})
	.describe("Уменьшение стоимости модификаторов позиции на бесплатные единицы.");
